import React from 'react';

import Banner from './Banner';

const UnsyncedDataBanner = () => (
    <Banner isWarning isDismissible>
        <div>You have unsaved results. Please click the Sync button to save results.</div>
    </Banner>
);

export default UnsyncedDataBanner;
